export enum RESPONSE_PAUSE_CODE {
  DIALOGUE,
  SCRIPT_LOAD,
  SCRIPT_JUMP,
  PLAYER_CHANGE_TYPE,
  VOCAB_DEFINE,
  VOCAB_GET,
  VARIABLE_DEFINE,
  TITLE_ADD_BUFFER,
  TITLE_POP,
  CHOICE_ADD_BUFFER,
  PROMPT_ASK_CHOICE,
  ERR_UNKNOWN_MACRO,
  ERR_MISSING_SCRIPT,
  PROMPT_ASK_STRING,
  EVAL_CONDITIONAL,
  EMPTY_LINE,
  LOG_CLEAR,
  LINE_JUMP,
  SCRIPT_END
}

export enum PLAYER_TYPE {
  TWO_COLUMNS,
  AUTO_DIALOG,
}
